import { BillingInfo } from "./payments/BillingInfo";
import { SettlementChoiceData } from "./payments/SettlementChoiceData";
import { StudentRegData } from "./registration/StudentRegData";

export class EnrolmentRequestInformation {
  server_guardian_id: number = 0
  server_country_id:number = 0;
  requests: Array<StudentRegData> = []

  settlement_choice = new SettlementChoiceData()
  billing_info  = new BillingInfo()
}
